import { Injectable } from '@angular/core';

import { Notification } from './models/notification.model';
import { NotificationComponentFactoryService } from './notification-component-factory/notification-component-factory.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  timeout: any;

  constructor(
    private componentFactory: NotificationComponentFactoryService) { }


  notification(options: Notification) {
    this.componentFactory.loadNotification(options);
  }
}
